import { mergeProps } from '@react-aria/utils';
import clsx from 'clsx';
import { FieldInputProps as FormikFieldInputProps, FieldMetaProps } from 'formik';
import React from 'react';

export interface FieldInputProps<V = any> {
  field: FormikFieldInputProps<V> & { id?: string };
  meta: FieldMetaProps<V>;
  disabled?: boolean | undefined;
  children?: React.ReactElement;
  type?: string;
  hideError?: boolean;
}

export function FieldInput({ children, meta, field, hideError, ...props }: FieldInputProps) {
  const { disabled } = props;
  const isError: boolean = hideError ? false : !!(meta.touched && meta.error);
  // id and aria-describedby added for aria feedback for forms, do not remove/move

  const isMarketingSettings = field.name === 'groups.MarketingSettings';

  const newProps =
    isError && !isMarketingSettings
      ? mergeProps(props, {
          'aria-describedby': `${field.id || field.name}_error`
        })
      : props;

  if (isMarketingSettings) {
    return null; // Return null when isMarketingSettings is true
  }

  return (
    !isMarketingSettings && (
      <div className={clsx('relative field-with-icons', isError && 'shadow-field-error')}>
        <input
          id={field.id || field.name}
          className={clsx(
            isError
              ? 'form-field-error'
              : disabled
              ? 'border-gray-20 text-gray-20 bg-white'
              : 'border-gray-default focus:border-primary-blue',
            children && 'rounded-r-none',
            'form-field placeholder-gray-default mb-0 border-0 focus:border-0 truncate'
          )}
          {...field}
          {...newProps}
        />
        {children}
      </div>
    )
  );
}
